const BASE_URL = "https://ta-service.sysbrew.in";

const Config = {
    customer: {
        url: `${BASE_URL}/customers.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        type: "customer",
        title: "Customers",
        url_save: `${BASE_URL}/addcustomers.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`
    },
    vendor: {
        url: `${BASE_URL}/vendors.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        type: "vendor",
        title: "Vendors",
        url_save: `${BASE_URL}/addvendors.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
    },
    order: {
        orderUrl: `${BASE_URL}/v2/orders.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        orderDetailUrl: `${BASE_URL}/v2/orderdetails.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA&id=`,
        title: "Orders"
    },
    item: {
        url: `${BASE_URL}/items.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        itemTypeUrl: `${BASE_URL}/item_types.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        title: "Items",
        type: "item",
        url_save_item: `${BASE_URL}/additems.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        url_save_item_type: `${BASE_URL}/additemtype.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        url_delete_item: `${BASE_URL}/deleteitems.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`,
        url_delete_item_type: `${BASE_URL}/deleteitemtype.php?cartoon=2b8816e457a2f577dffcccfabe1f261b&username=8884252513&client_code=GSA`
    }
}

export default Config;


// WEBPACK FOOTER //
// ./src/js/Config.js